<template>
  <div id="home">

    <div class="content">
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <div class="title">
          Call Inquiries
        </div>
        <div>
          <i class="el-icon-s-tools setting" style="font-size: 26px;font-weight: bold;cursor: pointer;color: #777777;" @click="show_setting_cols"></i>
        </div>
      </div>

      <div class="center" style="display: flex;justify-content: space-between;align-items: center;flex-wrap:wrap;">
        <div>
          <el-date-picker style="width: 100%;"
            v-model="value"
            type="daterange"
            :clearable="false"
            @change="changeTime"
            format="MM/dd/yyyy"
            placement="bottom-start">
          </el-date-picker>
          <i class="el-icon-arrow-down" style="color:gray;position: absolute;margin-left: -30px;margin-top: 12px;"></i>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <el-input placeholder="Search here" v-model="search" class="input-with-select" style="width: 300px;" :clearable="true">
            <el-button slot="append" icon="el-icon-search" @click="searchFunction"></el-button>
          </el-input>
          <!-- <el-input v-model="search" :clearable="true" style="width: 100%;" placeholder="Search"></el-input> -->
          <!-- <el-button @click="searchFunction">Search</el-button> -->
          <el-button style="background-color:#5856D6;color:#ffffff;margin-left: 15px;" size="medium" v-loading="downloadLoading" @click="download" icon="el-icon-download"></el-button>
        </div>
      </div>
      <div class="center" style="display: flex;align-items: center;justify-content: flex-start;flex-wrap:wrap;">
        <div style="font-weight: bold;">Filters</div>
        <el-select style="width: 240px;" v-model="select_category" placeholder="Category" clearable @change="getDatas(1)">
          <el-option v-for="item in category_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select v-model="select_status" placeholder="Status" clearable @change="getDatas(1)">
          <el-option v-for="item in status_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select v-model="select_new_client" placeholder="New Client" clearable @change="getDatas(1)">
          <el-option v-for="item in new_client_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select v-model="select_referral_source" placeholder="Referral Source" clearable @change="getDatas(1)">
          <el-option v-for="item in referral_source_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <el-table
        v-loading="table_loading"
        :data="tableData"
        @row-click="rowClick"
        @sort-change="order_change"
        class="round-header-table"
        :header-cell-style="{'background-color': '#A0ABC0', 'color': '#FFFFFF', 'font-weight': 'bold'}"
        :cell-style="{ fontSize: '14px'}"
        border
        style="width: 100%;">

        <el-table-column
          v-if="judge_show('CALL_DATETIME')"
          align="left"
          min-width="150"
          sortable
          prop="date"
          label="Date & Time">
          <template slot-scope="scope">
            {{moment(scope.row.created_datetime).format('MM/DD/YY')}}<br/>
            {{moment(scope.row.created_datetime).format('HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column
          v-if="judge_show('CALL_FROM')"
          align="center"
          prop="phone_from"
          min-width="180"
          label="Mobile Phone">
          <template slot-scope="scope" v-if="scope.row.phone_from">
            {{process_phone_number_format(scope.row.phone_from)}}
          </template>
        </el-table-column>

        <el-table-column
          v-if="judge_show('CALLER_NAME')"
          align="center"
          min-width="150"
          label="Caller">
          <template slot-scope="scope" v-if="scope.row.caller_name != null && scope.row.caller_name != 'null'">
            {{scope.row.caller_name}}
          </template>
        </el-table-column>

        <el-table-column
          v-if="judge_show('CALLEE_NAME')"
          align="center"
          min-width="150"
          label="Callee">
          <template slot-scope="scope" v-if="scope.row.callee_name != null && scope.row.callee_name != 'null'">
            {{scope.row.callee_name}}
          </template>
        </el-table-column>

        <el-table-column
          v-if="judge_show('CATEGORY')"
          align="center"
          min-width="150"
          label="Category">
          <template slot-scope="scope">
            {{translate_category(scope.row.category)}}
          </template>
        </el-table-column>

        <el-table-column
        v-if="judge_show('REFERRAL_SOURCE')"
          align="center"
          min-width="150"
          label="Referral Source">
          <template slot-scope="scope">
            {{translate_source(scope.row.referral_source)}}
          </template>
        </el-table-column>
        <el-table-column
        v-if="judge_show('NEW_CLIENT')"
          align="center"
          min-width="150"
          label="New Client">
          <template slot-scope="scope">
            {{translate_new_client(scope.row.new_client)}}
          </template>
        </el-table-column>
        <el-table-column
        v-if="judge_show('CONVERSION')"
          align="center"
          min-width="150"
          label="Conversion">
          <template slot-scope="scope" v-if="scope.row.conversion != null">
            {{scope.row.conversion ? 'Yes' : 'No'}}
          </template>
        </el-table-column>

        <el-table-column
        v-if="judge_show('APPOINTMENTS')"
          align="center"
          min-width="150"
          label="Appointments">
          <template slot-scope="scope" v-if="scope.row.appointments != null">
            {{scope.row.appointments ? 'Yes' : 'No'}}
          </template>
        </el-table-column>

        <el-table-column
        v-if="judge_show('AI_ANALYTICS')"
          align="center"
          min-width="150"
          label="AI Analytics">
          <template slot-scope="scope" v-if="scope.row.ai_analytics != null">
            {{scope.row.ai_analytics ? 'Yes' : 'No'}}
          </template>
        </el-table-column>

        <el-table-column
        v-if="judge_show('CUSTOMER_SATISFACTION')"
          align="center"
          min-width="200"
          sortable
          prop="customer_satisfaction"
          label="Customer Satisfaction">
          <template slot-scope="scope" v-if="scope.row.customer_satisfaction != null">
            {{scope.row.customer_satisfaction}}<i class="el-icon-star-on" style="margin-left: 1px;color: gold;font-size: 18px;"></i>
          </template>
        </el-table-column>

        <el-table-column
        v-if="judge_show('ISSUED_RESOLVED')"
          align="center"
          min-width="160"
          label="Issued Resolved">
          <template slot-scope="scope" v-if="scope.row.issued_resolved != null">
            {{scope.row.issued_resolved}}<i class="el-icon-star-on" style="margin-left: 1px;color: gold;font-size: 18px;"></i>
          </template>
        </el-table-column>

        <el-table-column
        v-if="judge_show('CALL_STATUS')"
          align="center"
          min-width="150"
          label="Status">
          <template slot-scope="scope">
            <el-tag type="success" size="small" v-if="scope.row.call_status == 'Answered'"><i class="el-icon-success" style="margin-right:3px;"></i>Answered</el-tag>
            <el-tag type="info" size="small" v-if="scope.row.call_status == 'Unknown'"><i class="el-icon-question" style="margin-right:3px;"></i>Unknown</el-tag>
            <el-tag type="warning" size="small" v-if="scope.row.call_status == 'Busy'"><i class="el-icon-warning" style="margin-right:3px;"></i>Busy</el-tag>
            <el-tag type="danger" size="small" v-if="scope.row.call_status == 'Missed call'"><i class="el-icon-error" style="margin-right:3px;"></i>Missed call</el-tag>
          </template>
        </el-table-column>

        <el-table-column
        v-if="judge_show('CALL_DURATION')"
          align="center"
          min-width="120"
          sortable
          prop="call_duration"
          label="Duration">
          <template slot-scope="scope">
            {{secondsToTime(scope.row.call_duration)}}
          </template>
        </el-table-column>

        <el-table-column
        v-if="judge_show('KEYWORDS')"
          align="center"
          min-width="120"
          label="Keywords">
          <template slot-scope="scope" v-if="scope.row.keywords">
            <el-tag size="mini" style="font-size: 12px;" v-for="(item,index) of scope.row.keywords" :key="index">{{item}}</el-tag>
          </template>
        </el-table-column>

        <el-table-column
        v-if="judge_show('COMMENT')"
          align="center"
          min-width="300"
          label="Comment">
          <template slot-scope="scope">
            <div style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{scope.row.comment}}</div>
          </template>
        </el-table-column>

        <el-table-column
        v-if="judge_show('SUMMARY')"
          align="center"
          min-width="300"
          label="Summary">
          <template slot-scope="scope">
            <div style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{scope.row.summary}}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Action"
          align="center"
          min-width="100">
          <template slot-scope="scope">
            <el-link type="primary" title="Detail" @click.stop="show_edit(scope.row.call_sid)"><i class="font-size-16 el-icon-search"></i></el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="page_size"
          :total="totalRows">
        </el-pagination>
      </div>
      <show ref="viewForm"></show>
      <table-title-setting ref="tableTitleSetting" @ok="getDatas(1)"></table-title-setting>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getActionApi,downFileApi } from '@/network/manageApi';
  import Show from './callInquiries/show'
  import TableTitleSetting from './callInquiries/tableTitleSetting'
  import moment from 'moment/moment';
  import { INITIALIZATION_DATE_CALL } from '@/store/mutation-types'
  export default {
    name: 'CallInquiries',
    components: {
      Show,TableTitleSetting
    },
    data() {
      return {
        value:[],
        totalRows: 0,
        current_page: 1,
        page_size: 10,
        tableData: [],
        table_loading: false,
        search:'',
        sort: '',
        downloadLoading:false,
        status_map: {"Answered":"Answered", "Missed call":"Missed call",
        "Busy": "Busy", "Unknown":"Unknown"},
        customIcon: 'el-icon-arrow-down',
        category_data: [{value: 'APPOINTMENT', label: 'APPOINTMENT'}, {value: 'GENERAL_INQUIRY', label: 'GENERAL INQUIRY'},
        {value: 'CANCEL_APPOINTMENT', label: 'CANCEL APPOINTMENT'},{value: 'COMPLAINT', label: 'COMPLAINT'},{value: 'UNKNOWN', label: 'UNKNOWN'},
        {value: 'APPOINTMENT_CHANGE', label: 'APPOINTMENT CHANGE'},{value: 'APPOINTMENT_CONFIRM', label: 'APPOINTMENT CONFIRM'}],
        select_category: '',
        status_data: [{value: 'ANSWERED', label: 'ANSWERED'}, {value: 'MISSED_CALL', label: 'MISSED CALL'}],
        select_status: '',
        new_client_data: [{value: 'NEW_CLIENT', label: 'NEW CLIENT'}, {value: 'NOT_NEW_CLIENT', label: 'NOT NEW CLIENT'}],
        select_new_client: '',
        referral_source_data: [{value: 'GOOGLE', label: 'GOOGLE'}, {value: 'FACEBOOK', label: 'FACEBOOK'}, {value: 'INSTAGRAM', label: 'INSTAGRAM'},
        {value: 'LINKEDIN', label: 'LINKEDIN'}, {value: 'YELP', label: 'YELP'}, {value: 'WEBSITE', label: 'WEBSITE'}, {value: 'ETC', label: 'ETC'},
        {value: 'UNKNOWN', label: 'UNKNOWN'}],
        select_referral_source: '',
        selected_columns: ["CATEGORY","SUMMARY","CONVERSION","APPOINTMENTS","AI_ANALYTICS","KEYWORDS","CUSTOMER_SATISFACTION","ISSUED_RESOLVED","COMMENT","CALLER_NAME","CALLEE_NAME","NEW_CLIENT","REFERRAL_SOURCE","CALL_FROM","CALL_DURATION","CALL_DATETIME","CALL_STATUS"]
      }
    },
    computed: {

    },
    mounted() {

    },
    created(){
      if(!Vue.ls.get(INITIALIZATION_DATE_CALL)) {
        Vue.ls.set(INITIALIZATION_DATE_CALL, [moment().add(-1,'months').format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')])
      }
      this.value = Vue.ls.get(INITIALIZATION_DATE_CALL)
      this.getDatas(1)
    },
    methods:{
      show_setting_cols() {
        this.$refs.tableTitleSetting.init()
      },
      judge_show(item) {
        return this.selected_columns.includes(item)
      },
      padZero(num, length) {
          return String(num).padStart(length, '0');
      },
      secondsToTime(seconds) {
        if(seconds) {
          if(seconds > 3600) {
            return this.padZero(Math.floor(seconds/3600), 2) + ":" + this.padZero(Math.floor(seconds%3600/60), 2) + ":" + this.padZero(Math.floor(seconds%60), 2)
          } else {
            return this.padZero(Math.floor(seconds/60), 2) + ":" + this.padZero(Math.floor(seconds%60), 2)
          }
        } else {
          return "00:00"
        }
      },
      translate_source(status) {
        if(status == null || status == 'UNKNOWN') {
          return "";
        } else {
          return status
        }
      },
      moment,
      order_change(column, prop, order ) {
        this.sort = ''
        if(column.order != null){
          this.sort = column.prop + '_'
          if(column.order == "ascending")
            this.sort = this.sort + 'asc'
          else
            this.sort = this.sort + 'desc'
        }
        this.getDatas(1)
      },
      format_phone(localNumber, countryCode) {
        const phoneFormats = {          "+1": "(XXX) XXX-XXXX", // USA, Canada          "+44": "07XXX XXXXXX",   // UK Local Mobile          "+91": "XXXXX-XXXXX",   // India          "+61": "XXXX XXX XXX",  // Australia          "+81": "XXX-XXXX-XXXX", // Japan          "+49": "XXXX XXXXXXX",  // Germany          "+33": "X XX XX XX XX",  // France          "+55": "(XX) XXXXX-XXXX" // Brazil        };
        let format = phoneFormats[countryCode] || "XXXX-XXXX-XXXX";
        let digits = localNumber.replace(/\D/g, "");
        let formattedNumber = "";        let digitIndex = 0;        // +44 07577 318158        for (let char of format) {            if (char === "X" && digitIndex < digits.length) {                formattedNumber += digits[digitIndex];                digitIndex++;            } else {                formattedNumber += char;            }        }        return `${countryCode} ${formattedNumber}`;      },
      process_phone_number_format(phone) {
        if(!phone) {
          return "";
        }
        if(phone == "Anonymous"
        || phone == "anonymous") {
          return "Anonymous";
        }
        let countryCode = this.get_phone_countryCode(phone)
        let phone_cl = phone.replaceAll("-", "").replaceAll(countryCode, "");
        if(countryCode == "+44") {
          if(phone_cl.indexOf("7") == 0 && phone_cl.length == 10) {
            phone_cl = phone_cl.substring(1);
          } else if(phone_cl.indexOf("07") == 0 && phone_cl.length == 11) {
            phone_cl = phone_cl.substring(2);
          }
        }
        return this.format_phone(phone_cl,countryCode)
      },
      get_phone_countryCode(phone) {
        if(phone.indexOf("+55") != -1) {
          return "+55";
        } else if(phone.indexOf("+33") != -1) {
          return "+33";
        } else if(phone.indexOf("+49") != -1) {
          return "+49";
        } else if(phone.indexOf("+81") != -1) {
          return "+81";
        } else if(phone.indexOf("+61") != -1) {
          return "+61";
        } else if(phone.indexOf("+91") != -1) {
          return "+91";
        } else if(phone.indexOf("+44") != -1) {
          return "+44";
        } else if(phone.indexOf("+1") != -1) {
          return "+1";
        } else {
          return ""
        }
      },
      translate_new_client(str){
        if(str == null || str == "" || str == "UNKNOWN") {
          return "";
        } else if(str == "YES") {
          return "Yes"
        } else if(str == "NO") {
          return "No"
        }
      },
      translate_status(status) {
        if(status) {
          return this.status_map[status]
        }
        return;
      },
      translate_category(status) {
        if(status) {
          return status.replaceAll("_", " ")
        }
        return;
      },
      show_edit(id) {
        this.$refs.viewForm.init(id)
      },
      rowClick(row){
        this.$refs.viewForm.init(row.call_sid)
      },
      searchFunction(){
        this.getDatas(1)
      },
      download(){
        if(this.downloadLoading)
          return
        const that = this
        that.downloadLoading = true
        let params = {date_from:moment(this.value[0]).format('YYYY-MM-DD'),date_to:moment(this.value[1]).format('YYYY-MM-DD'),search:this.search.trim()}
        if(this.sort != '')
          params.sorting = this.sort
        if(this.select_category != '')
          params.category_filter = this.select_category
        if(this.select_status != '')
          params.call_status_filter = this.select_status
        if(this.select_new_client != '')
          params.new_client_filter = this.select_new_client
        if(this.select_referral_source != '')
          params.referral_source_filter = this.select_referral_source
        downFileApi("/inquiry/call-inquiry/download1?size=" + this.page_size + "&page=" + this.current_page,params).then((res) => {
          const url = window.URL.createObjectURL(new Blob([res]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download','call_inquiries.xlsx')
          document.body.appendChild(link)
          link.click()
          that.downloadLoading = false
        })
      },
      changeTime(e){
        Vue.ls.set(INITIALIZATION_DATE_CALL, this.value)
        this.getDatas(1)
      },
      async getDatas(initSize) {
        if(initSize == 1) {
          let res = await getActionApi("/inquiry/call-inquiry/columns")
          this.selected_columns = res.data.selected_columns
        }
        this.current_page = initSize
        this.table_loading = true
        let params = {date_from:moment(this.value[0]).format('YYYY-MM-DD'),date_to:moment(this.value[1]).format('YYYY-MM-DD'),search:this.search.trim()}
        if(this.sort != '')
          params.sorting = this.sort
        if(this.select_category != '')
          params.category_filter = this.select_category
        if(this.select_status != '')
          params.call_status_filter = this.select_status
        if(this.select_new_client != '')
          params.new_client_filter = this.select_new_client
        if(this.select_referral_source != '')
          params.referral_source_filter = this.select_referral_source
        let data_res = await getActionApi("/inquiry/call-inquiry1?size=" + this.page_size + "&page=" + this.current_page,params)
        this.tableData = data_res.data
        this.totalRows = data_res.page.totalElements
        this.table_loading = false
      },
      handleCurrentChange(val) {
        this.getDatas(val)
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;word-break:normal;}
  #home{background-color:#F8F9FA;padding:20px;display: grid;gap: 20px;}
  .content{background-color: #ffffff;padding: 30px;display: grid;gap: 20px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);border-radius: 16px;}
  .title{color:#2D3648;font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;align-items: center;}
  .title div{display: flex;align-items: center;}
  .title div *{padding:10px 16px;font-size: 14px;}
  .pager{display: flex;justify-content: center;}
  .font-size-16 {font-size: 20px;}
  .margin-top-switch {margin-top: 10px;}
  .center{display:inline-grid;grid-gap: 10px;grid-template-columns: 300px 300px 300px 100%;}
  .avatar-uploader-icon {font-size: 18px;color: #8c939d;}
  .headImageShow {width: 76px;height: 76px;border-radius: 4px;}
  @media (max-width: 768px) {
    .title{flex-direction: column;}
    .title div{margin-top:20px;}
    .center{display: grid;grid-template-columns: 1fr;}
    .content{padding:20px 5px;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .center{display:inline-grid;grid-gap: 10px;grid-template-columns: 250px 200px 100%;}
  }
  .setting:hover {color: #000000 !important;}
  .round-header-table {
    /* border-radius: 8px; */
    /* overflow: hidden; */
  }

  .round-header-table .el-table__header-wrapper {
    border-radius: 8px 8px 0 0;
    overflow: hidden;
  }

  .round-header-table .el-table__header th.el-table__cell {
    background-color: #f5f7fa;
    color: #303133;
    font-weight: bold;
    border: none; /* 去除默认边框 */
    border-right: 1px solid #e8e8e8; /* 自定义右侧边框 */
  }

  .round-header-table .el-table__header th.el-table__cell:first-child {
    border-radius: 8px 0 0 0;
  }

  /* 最后一个表头单元格 - 右上角圆角 */
  .round-header-table .el-table__header th.el-table__cell:last-child {
    border-radius: 0 8px 0 0;
    border-right: none; /* 去除最后一个单元格的右边框 */
  }

  /* 处理表格边框 */
  .round-header-table .el-table__body td.el-table__cell {
    border-right: 1px solid #e8e8e8;
  }

  .round-header-table .el-table__body td.el-table__cell:last-child {
    border-right: none;
  }

  /* 去除表头底部边框，通过添加表格顶部边框实现视觉连续 */
  .round-header-table .el-table__header {
    border-bottom: none;
  }

  .round-header-table .el-table__body {
    border-top: 1px solid #e8e8e8;
  }

  /* 如果使用scoped样式，需要使用::v-deep穿透 */
  ::v-deep .round-header-table .el-table__header-wrapper {
    border-radius: 8px 8px 0 0;
    overflow: hidden;
  }

  ::v-deep .round-header-table .el-table__header th.el-table__cell {
    background-color: #f5f7fa;
    color: #303133;
    font-weight: bold;
    border: none;
    border-right: 1px solid #e8e8e8;
  }

  ::v-deep .round-header-table .el-table__header th.el-table__cell:first-child {
    border-radius: 8px 0 0 0;
  }

  ::v-deep .round-header-table .el-table__header th.el-table__cell:last-child {
    border-radius: 0 8px 0 0;
    border-right: none;
  }
  ::v-deep .el-table--border, .el-table--group {
    border: 1px solid #EBEEF5;
    border-radius: 8px 8px 0 0;
  }
</style>
